// extracted by mini-css-extract-plugin
module.exports = {"modalOuter":"_2AIs9","questionHeading":"_2uc_L","subHeadingAnswer":"_7kcOC"};